import { UIComponent } from "@aptus/frontend-core";
import { A } from "components/a";
import { Trans, useTranslation } from "react-i18next";
import styles from "./cookieConsentBanner.module.css";

interface Props {
	cookiePolicyURL: string;

	acceptCookies: () => void;
	rejectCookies: () => void;
}

export const CookieConsentBanner: UIComponent<Props> = ({
	cookiePolicyURL,
	acceptCookies,
	rejectCookies,
}) => {
	const { t } = useTranslation();

	return (
		<aside className={styles["cookie-consent-banner"]} role="dialog" aria-live="polite" aria-label={t("cookies.label")}>
			<p className={styles.explanation}>
				<Trans i18nKey="cookies.explanation" components={{ italic: <A href={cookiePolicyURL} />, br: <br /> }} />
			</p>
			<div className={styles["actions-wrapper"]}>
				<button onClick={rejectCookies} type="button" className="secondary">{t("cookies.reject")}</button>
				<button onClick={acceptCookies} type="button">{t("cookies.accept")}</button>
			</div>
		</aside>
	);
};
